<script setup>
import { ref, useTemplateRef } from "vue";

const imageRef = useTemplateRef("imageRef");
const ratio = ref(0);

const { src, alt } = defineProps({
    alt: {
        type: String,
    },
    src: {
        type: String,
    },
});

const onLoad = () => {
    if (!imageRef) return;
    ratio.value = imageRef.value.naturalHeight / imageRef.value.naturalWidth;
};

const onError = () => {
    // TODO: remove border-radius of the preview so complete alt is visible.
};
</script>

<template>
    <img
        @load="onLoad"
        @error="onError"
        ref="imageRef"
        class="preview-image"
        :alt="alt"
        :src="src"
        height="280"
        width="280"
        :data-img-ratio="ratio"
    />
</template>
